import React from "react";
import styled from "styled-components";

// components
import ToolsMenu, {
    AnchorStyled
} from "core/SiteHeader/components/ToolsMenu.js";
import Accordion from "core/Accordion";
import { ControlStyled } from "core/Accordion/styles";

// data
import { trackheaderToolsClicked } from "core/trackEvent";

// styles
import colors, { focusStyles } from "core/colors";
import { convertPxToRem } from "frontend/components/helpers";
import { regular, textMd } from "core/fontStyles";

const ToolsStyled = styled.nav`
    text-align: left;

    ${ControlStyled} {
        ${textMd}
        ${regular}
        color: ${colors.secondary.orca};
        padding: ${convertPxToRem(12)} ${convertPxToRem(16)};
        border-top: solid ${convertPxToRem(2)} ${colors.primary.diamond};

        transition: opacity 0.5s ease;

        &:hover {
            opacity: 0.6;
            background-color: ${colors.accent.lightMode.dewdrop};
        }

        &:focus {
            ${focusStyles}
        }
    }
`;

const WrapperStyled = styled.div`
    padding: ${convertPxToRem(12)} ${convertPxToRem(16)};
`;

const ToolsMenuStyled = styled(ToolsMenu)`
    display: flex;
    flex-direction: column;
    gap: ${convertPxToRem(16)};

    ${AnchorStyled} {
        font-size: ${convertPxToRem(15)};
    }
`;

// data
import { primaryMenu } from "data/links";

// component
export const Tools = () => {
    return (
        <ToolsStyled>
            <Accordion
                controlTitle={primaryMenu.products.links.tools.name}
                onOpen={trackheaderToolsClicked}
                contentMaxHeight={300}
            >
                <WrapperStyled>
                    <ToolsMenuStyled
                        linkColor={colors.accent.lightMode.persian}
                        linkHoverColor={colors.accent.lightMode.navy}
                    />
                </WrapperStyled>
            </Accordion>
        </ToolsStyled>
    );
};

export default Tools;
